var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-application v-application--is-ltr theme--light",attrs:{"id":"app","data-app":"true"}},[(_vm.initializationFinished)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e(),_c('snack-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }